export default __webpack_public_path__ + "1b74b0659664ca1715811ad8ca242aac.svg";